import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import CalendarDeadlines from "./calendar";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import moment from "moment";
import { DATE_FORMAT_FOR_API } from "../../../constants/constants";
import {
  getDeadlines,
  getDeadlinesMonth,
  toggleArchivedDeadline
} from "../../../store/actions/deadlines/company";
import { useEffect } from "react";
import { getFromDate } from "../commonFunctions";
import { getEffectiveOrNot } from "../../../store/actions/deadlines/accountant";
import { useLocation } from "react-router-dom";
import { getLastDateOfMonth } from "../../../libs/deadlinesUtils";
import { FormattedMessage } from "react-intl";

const ClientDeadlines = props => {
  const {
    customersView,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    companyUuidSelected,
    clientIdSelected,    
    myType,
    prevPath,
    setCustomersView,
    classifierCompanySelected,
    balanceDetailDialog,
    setBalanceDetailDialog
  } = props;

  const deadlinesCompany = useSelector(state => state.deadlinesCompany);
  const location = useLocation();
  const subjective = deadlinesCompany ? deadlinesCompany.subjective : [];

  const dispatch = useDispatch();
  const [filterOnSingleDay, setFilterOnSingleDay] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [paymentsStatus, setPaymentsStatus] = useState(null);
  const [archived ] = useState(false);
  const [updateCalendar, setUpdateCalendar] = useState(true);
  const [subjectiveMonthView, setSubjectiveMonthView] = useState(deadlinesCompany ? deadlinesCompany.subjective : []);
  const [subjectiveMonth, setSubjectiveMonth] = useState(deadlinesCompany ? deadlinesCompany.subjectiveMonth : []);
  const [filtersCalendar, setFiltersCalendar] = useState({
    confirmed: null,
    scope: null
  });
  const [queryParameters, setQueryParameters] = useState({
    scope:
      localStorage.getItem("queryParameters") &&
      localStorage.getItem("queryParameters") !== "undefined"
        ? localStorage.getItem("queryParameters")
        : []
  });
  const [filtersList, setFiltersList] = useState({
    activeFilters: localStorage.getItem("activeFilterList")
      ? [localStorage.getItem("activeFilterList")]
      : [],
    fromSelected: getFromDate(customersView),
    monthView: true
  });

  useEffect(() => {
    dispatch(getEffectiveOrNot(
      false,
      null,
      true,
      {
        archived: false,
        confrirmed: filtersCalendar.confirmed,
        expired: false,
        fromDate: fromDate,
        toDate: toDate,
        scope: queryParameters.scope,
        status: filtersList.activeFilters
      },
      false
    ));
  }, [filtersList.fromSelected, queryParameters.scope]);

  useEffect(() => {
    if (location.state && location.state.reloadData) {
      if (fromDate) {
        dispatch(getDeadlinesMonth(
          fromDate,
          toDate,
          null,
          null,
          null, // queryParameters.scope,
          paymentsStatus,
          archived,
          filtersCalendar.confirmed
        )).then(res => {
          dispatch(getDeadlines(
            true,
            true,
            fromDate,
            toDate,
            null,
            null,
            null,
            null,
            queryParameters.scope,
            paymentsStatus,
            archived,
            filtersCalendar.confirmed
          ));
        });
      }
    }
  }, []);

  useEffect(() => {
    let fromDate;
    if (localStorage.getItem("calendarFromDate") && customersView) {
      fromDate = localStorage.getItem("calendarFromDate");
    }
    if (!fromDate) {
      // Set first and last day of month

      const date = new Date(props.customersView && props.fromDate
          ? props.fromDate
          : moment().format(DATE_FORMAT_FOR_API)),
        y = date.getFullYear(),
        m = date.getMonth();

      const firstDay = new Date(
        y, m, 1
      );
      const tzoffset = new Date(firstDay).getTimezoneOffset() * 60000;
      fromDate = new Date(firstDay - tzoffset).toISOString().split("T")[0];
    }
    setFromDate(fromDate);
  }, [customersView]);

  useEffect(() => {
    let toDate;    
    if (localStorage.getItem("calendarToDate") && customersView) {
      toDate = localStorage.getItem("calendarToDate");
      
    }
    if (!toDate) {      
      // Set first and last day of month
      const tzoffset = new Date().getTimezoneOffset() * 60000;
      const date = new Date(props.customersView && props.fromDate
          ? props.fromDate
          : moment().format(DATE_FORMAT_FOR_API)),
        y = date.getFullYear(),
        m = date.getMonth();

      const lastDay = !props.customersView
        ? new Date(
          y + 1, 11, 31
        )
        : new Date(
          y, m + 1, 0
        );

      toDate = new Date(lastDay - tzoffset).toISOString().split("T")[0];
    }
    setToDate(toDate);
  }, [customersView]);

  useEffect(() => {
    if (!fromDate) return;
    dispatch(getDeadlinesMonth(
      fromDate,
      toDate,
      null,
      null,
      null, // queryParameters.scope,
      paymentsStatus,
      archived,
      filtersCalendar.confirmed
    )).then(res => {
      dispatch(getDeadlines(
        true,
        true,
        fromDate,
        toDate,
        null,
        null,
        null,
        null,
        queryParameters.scope,
        paymentsStatus,
        archived,
        filtersCalendar.confirmed
      ));
    });
  }, [queryParameters, fromDate, toDate, filtersList.activeFilters]);

  useEffect(() => {
    if (updateCalendar) {
      setSubjectiveMonthView(deadlinesCompany ? deadlinesCompany.subjective : []);
      setSubjectiveMonth(deadlinesCompany ? deadlinesCompany.subjectiveMonth : []);
    }
  }, [subjective]);

  // useEffect(() => {
  //   dispatch(
  //     getDeadlines(
  //       auth,
  //       accountantUuidSelected,
  //       companyUuidSelected,
  //       fromDate,
  //       toDate,
  //       null,
  //       null,
  //       queryParameters.scope,
  //       paymentsStatus,
  //       archived,
  //       filtersCalendar.confirmed
  //     )
  //   );
  // }, [filtersList.activeFilters]);

  const filterTypeCalendar = (scope, confirmed = null) => {
    setUpdateCalendar(true);
    const newFromDate = filterOnSingleDay
      ? moment(selectedDay)
        .startOf("month")
        .format(DATE_FORMAT_FOR_API)
      : fromDate;
    setFromDate(newFromDate);
    
    setToDate(filterOnSingleDay
      ? moment(selectedDay)
        .endOf("month")
        .format(DATE_FORMAT_FOR_API)
      : toDate);
    setFiltersList({ ...filtersList, fromSelected: newFromDate });
    setFiltersCalendar({ ...filtersCalendar, confirmed: confirmed });    
    setQueryParameters({ ...queryParameters, scope: scope });
    setFilterOnSingleDay(false);

    // onSetFiltersList(filtersList.activeFilters, fromDate, toDate);
  };

  const splitValues = values => {
    let vArchived = false;
    let payStatus = [];
    for (let i = 0; i < values.length; i++) {
      // per semplicità nella chiave ho il tipo e il value separati da _
      let splitValToType = values[i].split("_");
      if (splitValToType[0] === "includeArchived") {
        vArchived = true;
      } else if (splitValToType[0] === "status") {
        payStatus.push(splitValToType[1]);
      }
    }
    return [vArchived, payStatus];
  };

  const onSetFiltersList = (
    values,
    vFromDate,
    vToDate,
    monthV,
    vDate,
    reload
  ) => {

    const payStatus = values;
    setPaymentsStatus(payStatus);
    if (vFromDate) {
      setFromDate(vFromDate);
    }
    
    if (vToDate) {
      setToDate(vToDate);
    }
    setFiltersList({
      activeFilters: values,
      monthView:
        monthV !== undefined && monthV !== null
          ? monthV
          : filtersList.monthView,
      fromSelected:
        vDate !== undefined && vDate !== null ? vDate : filtersList.fromSelected
    });
    if (reload) {
      dispatch(getEffectiveOrNot(
        false,
        null,
        true,
        {
          archived: false,
          confrirmed: filtersCalendar.confirmed,
          expired: false,
          fromDate: fromDate,
          toDate: toDate,
          scope: queryParameters.scope,
          status: payStatus
        },
        false
      ));
    }
  };

  const onChangeDateFilter = (year, month) => {
    let selectedMonth = new Date(year, month);
    let endOfMonth = new Date(
      selectedMonth.getFullYear(),
      selectedMonth.getMonth() + 1,
      0
    );

    selectedMonth = moment(selectedMonth).format(DATE_FORMAT_FOR_API);
    endOfMonth = moment(endOfMonth).format(DATE_FORMAT_FOR_API);
    setUpdateCalendar(true);
    setFilterOnSingleDay(false);
    setFromDate(selectedMonth);
    
    setToDate(endOfMonth);
    setFiltersList({ ...filtersList, fromSelected: selectedMonth });
  };

  const onDayClick = value => {
    let momentValue = moment(value).format(DATE_FORMAT_FOR_API);
    setUpdateCalendar(false);
    setSelectedDay(value);
    setFilterOnSingleDay(true);

    // uso la funzione che setta i filtri per la chiamata e per riapplicare i filtri
    onSetFiltersList(
      filtersList.activeFilters,
      momentValue,
      momentValue,
      false,
      value
    );
  };

  const onDayHover = value => {
    setSelectedDay(value);
  };

  const resetMonthView = () => {
    let today = new Date();
    const storeMonth = localStorage.getItem("monthFilterDeadlines")
      ? localStorage.getItem("monthFilterDeadlines")
      : today.getMonth();
    const storeYear = localStorage.getItem("yearFilterDeadlines")
      ? localStorage.getItem("yearFilterDeadlines")
      : today.getFullYear();

    today = new Date(parseInt(storeYear), parseInt(storeMonth));

    const endOfMonth = getLastDateOfMonth(today.getMonth(), today.getFullYear());

    let fromDateMoment = moment(today).format(DATE_FORMAT_FOR_API);
    let toDateMoment = moment(endOfMonth).format(DATE_FORMAT_FOR_API);

    setSelectedDay(null);
    setFilterOnSingleDay(false);
    setFromDate(fromDateMoment);
    setToDate(toDateMoment);

    // uso la funzione che setta i filtri per la chiamata e per riapplicare i filtri
    onSetFiltersList(
      filtersList.activeFilters,
      fromDateMoment,
      toDateMoment,
      true,
      fromDateMoment
    );
  };

  const toggleArchived = deadline => {
    dispatch(toggleArchivedDeadline(deadline,
      null));
  };

  const onChangeDatePicker = (name, value) => {
    switch (name) {
    case "fromDate.toDate":
      const month = new Date(value).getMonth();
      const year = new Date(value).getFullYear();
      onChangeDateFilter(month, year);
      break;

    case "scopes":
      filterTypeCalendar(value, filtersCalendar.confirmed);

      break;
    default: {
      break;
    }
    }
  };

  const [, filters] = splitValues(filtersList.activeFilters);
  return (
    <div>
      {deadlinesCompany &&
      deadlinesCompany.subjective &&
      !deadlinesCompany.isGettingDeadlines &&
      !deadlinesCompany.isGettingDeadlinesMonth &&
      fromDate ? (
          <CalendarDeadlines
            filterOnSingleDay={filterOnSingleDay}
            filterTypeCalendar={filterTypeCalendar}
            filtersList={filtersList}
            filtersCalendar={filtersCalendar}            
            dateSelected={fromDate}
            onChangeDateFilter={onChangeDateFilter}
            onDayClick={onDayClick}
            onDayHover={onDayHover}
            resetMonthView={resetMonthView}
            selectedDay={selectedDay}
            companySelected={companySelected}
            myType={myType}
            setFilterList={values => {
              onSetFiltersList(
                values,
                null,
                null,
                filtersList.monthView,
                filtersList.fromSelected,
                true
              );
              setUpdateCalendar(true);
            }}
            subjectiveMonthView={subjectiveMonthView}
            subjectiveMonth={subjectiveMonth}
            toggleArchivedDeadline={toggleArchived}
            prevPath={prevPath}
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            clientIdSelected={clientIdSelected}
            onChangeDatePicker={onChangeDatePicker}
            customersView={customersView}
            companyUuidSelected={companyUuidSelected}
            classifierCompanySelected={classifierCompanySelected}
            scope={queryParameters.scope}
            archived={archived}
            filters={filters}
            setCustomersView={setCustomersView}
            balanceDetailDialog={balanceDetailDialog}
            setBalanceDetailDialog={setBalanceDetailDialog}
          />
        ) : (
          <div style={{ textAlign: "center" }}>
            <Spin
              indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
              size="large"
              tip={<span><FormattedMessage id="generic.loading1" /> <FormattedMessage id="generic.loading2" /></span>}
              style={{ fontSize: "20px" }}
            />
          </div>
        )}
    </div>
  );
};

export default ClientDeadlines;
